module.exports = __webpack_public_path__ + "static/Figma-hero-0d679019c3af1ea4a9aee7121865778c.png";